<template>
  <section class="section" id="transactions-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <invoices-pack-title @get-invoices-pack="getInvoicesPack" />

      <invoices-pack-table :invoicesPacks="invoicesPacks" />
      <!-- <h2
        v-if="purchasesInvoicesQty === 0"
        class="subtitle has-text-centered is-spaced"
        style="margin-top: 5rem;"
      >
        {{ $t("invoice.noInvoices") }}
      </h2>

      <div v-else>
        <div>
          <b-pagination
            :total="purchasesInvoicesQty"
            v-model="current"
            order="is-centered"
            :per-page="perPage"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
            @change="changePage"
          ></b-pagination>

          <p class="has-text-centered" style="margin-bottom: 1rem;">
            {{ $t("invoice.showing") }} {{ perPage }}
            {{ $t("invoice.invoicesPerPage") }}
          </p>

          <p
            class="has-text-centered"
            style="margin-bottom: 1rem; font-weight: bolder; font-size: 1.5rem;"
            v-show="merchantStoreName != ''"
          >
            {{ merchantStoreName }}
          </p>

          <purchases-invoices-table
            :purchases-invoices="purchasesInvoices"
            :show-buyer="!merchantStoreName"
            @is-loading="loading"
            @download-invoice="downloadInvoice"
          />
          <br />

          <b-pagination
            :total="purchasesInvoicesQty"
            v-model="current"
            order="is-centered"
            :per-page="perPage"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
            @change="changePage"
          ></b-pagination>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { mapGetters } from "vuex";
import invoicesPackTitle from "./InvoicesPackTitle";
import invoicesPackTable from "./invoices-pack-table/InvoicesPackTable";

export default {
  mixins: [common, mask],

  components: {
    invoicesPackTitle,
    invoicesPackTable
  },

  data() {
    return {
      isLoading: false,
      current: 1,
      perPage: 100
    };
  },

  methods: {
    getInvoicesPack(skip) {
      if (isNaN(skip)) {
        skip = (this.current - 1) * this.perPage;
      }

      this.seeDetails = false;
      this.isLoading = true;
      this.$store
        .dispatch("getInvoicesPack", {
          skip,
          limit: this.perPage
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.currentCurrency = this.currency;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadInvoice(data) {
      this.$store
        .dispatch("downloadInvoice", {
          access_key: data.access_key
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    changePage(p) {
      const skip = (p - 1) * this.perPage;
      this.getPurchasesInvoices(skip);
    },

    loading(value) {
      this.isLoading = value;
    }
  },

  computed: {
    ...mapGetters(["invoicesPacks", "invoicesPackQty"])
  },

  mounted() {
    this.getInvoicesPack();
  }
};
</script>

<style scoped>
#transactions-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
